import client from './api-client';

export const getConfiguracionForm = async(query) => {
    try {        
        const response = await client.getSelect(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_formInf: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }
    } catch(error){
        throw error;
    }
}
export const getDetalles = async (query) => {
    try {
        const response = await client.getSelect(`detalles?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
export const getResponsables = async (query) => {
    try {
        const response = await client.get(`informes/responsables?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
export const getGestores = async(query) => {
    try {
        
        const response = await client.getSelect(`proveedores-rol?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }
    } catch(error){
        throw error;
    }
}
export const getInformesPrevios= async(query) => {
    try {
        
        const response = await client.get(`informes/defensa-cias?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {            
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const postGenerarInforme = async(file) => {
    try {
        
        const response = await client.post('informes/defensa-cias', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaGenerar: response.data};
        } else {
            return {respuestaGenerar: response.data};
        }
        
    } catch(error){
        throw error;
    }
}